import React from "react";
import Modal from "../modal";
import { FormSelector } from "../task-list/components/form-selector";
import "./advanced-filters.scss";
import { ApplyAdvancedFilters } from "../apply-advanced-filters/apply-advanced-filters";
import { useAdvancedFiltersForm } from "../../shared/hooks/use-advanced-filters-form";

export const AdvancedFilters = ({ open }) => {
    const { task, appliedFilters, filtersModel, handleSubmit, onSubmit, handleClose, handleClearAllFilters, handleClearFilter, onClose } =
        useAdvancedFiltersForm();

    return (
        <Modal cssClass="advanced-filters-modal" show={open} onClose={onClose}>
            <h2 className="advanced-filters-header">Advanced filters</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="advanced-filters-body">
                    <FormSelector task={task} />
                </div>
                <div className="advanced-filters-apply-section">
                    <ApplyAdvancedFilters
                        filtersModel={filtersModel}
                        appliedFilters={appliedFilters}
                        onClearFilter={handleClearFilter}
                        onClearAllFilters={handleClearAllFilters}
                    />
                </div>
                <div className="button-group -right m-t-16 p-l-12 p-r-12">
                    <button type="button" className="button " onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="submit" className="button -primary">
                        Apply filters
                    </button>
                </div>
            </form>
        </Modal>
    );
};
